window.RS = window.RS || {};
RS.template = (function() {
  const SUBSCRIPTION = "SEY Coffee Subscription";
  const REVEAL = "reveal";
  const INCREASE = 'increase';
  const DECREASE = 'decrease';
  const PROP_ICON_INDEX = '--icon-index';
  const CAF = "Caffeinated";
  const DE_CAF = "Decaffeinated";
  const COFFEE = "Coffee";
  const TWO_POUND = "2lb";
  const TWO_FIFTY = "250g";
  const BAG_OPTION = 'bag';
  const BOX_OPTION = 'box';
  const ZERO_DOLLAR = '$0';
  const PRICE_WRAPPER_CL = 'm__price-wrapper'; // CL for class names, EL for class reference e.g. .class
  const PRICE_CL = 'm__price';
  const PRICE_COMPARED_CL = 'm__compared-price';
  const DIM = 'dimmed';
  const boxSVG = function(index = 0) {
    return `
      <?xml version="1.0" encoding="UTF-8"?>
        <svg style="${PROP_ICON_INDEX}:${index};" width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="45" height="45" fill="white"/>
        <path d="M3.5 42.75V3.5H42.75V42.75H3.5Z" fill="var(--sey-box-bg, #9e4738)" stroke="var(--sey-box-border, #000)"/>
        <path d="M0.502691 45.5C0.76898 20.7678 20.7678 0.76898 45.5 0.502691V45.5H0.502691Z" fill="white" stroke="var(--sey-box-border, #000)"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M29.1397 37.1833C28.75 36.9597 28.4817 36.7936 28.4817 36.4806C28.4817 36.1356 28.8778 35.9886 29.2419 35.9886C29.6061 35.9886 29.9192 36.1164 30.2386 36.3783V35.7139C29.9255 35.535 29.5869 35.4456 29.2355 35.4456C28.5072 35.4456 27.9194 35.8928 27.9194 36.57C27.9194 37.1386 28.405 37.4517 28.7819 37.6817C28.8321 37.7115 28.8835 37.7413 28.9351 37.7714C29.3703 38.0243 29.8297 38.2914 29.8297 38.6911C29.8297 39.0617 29.5103 39.2406 29.1333 39.2406C28.6414 39.2406 28.2708 39.0681 27.9322 38.7231V39.4514C28.2772 39.6814 28.7244 39.7772 29.1397 39.7772C29.9383 39.7772 30.3983 39.2597 30.3983 38.6336C30.3983 37.9004 29.8206 37.5729 29.1715 37.205L29.1333 37.1833H29.1397ZM32.7686 37.8733H34.3978V37.3303H32.7686V36.0397H34.4617V35.503H32.1617V39.7197H34.5192V39.183H32.7686V37.8733ZM37.5092 37.0811L38.6592 35.503H39.3939L37.8286 37.6114V39.7261H37.2089V37.6114L35.65 35.503H36.3783L37.5092 37.0811Z" fill="var(--sey-box-border, #000)"/>
        <rect x="0.5" y="0.5" width="45" height="45" stroke="var(--sey-box-border, #000)"/>
        </svg>
    `;
  };
  const bagSVG = function(index = 0) {
    return `<?xml version="1.0" encoding="UTF-8"?><svg style="${PROP_ICON_INDEX}:${index};" width="54" height="54" viewBox="0 0 54 54"><rect x="1" y="1" width="52" height="52" fill="#fff"/><path d="m10.81,43.19V9.83h33.36v33.36H10.81Z" fill="var(--sey-bag-bg, #9e4738)" stroke="var(--sey-bag-border, #000)"/><path fill="#fff" d="m35.63,13.39c-.25-.14-.42-.25-.42-.45,0-.22.25-.31.49-.31s.43.08.64.25v-.43c-.2-.11-.42-.17-.64-.17-.47,0-.84.29-.84.72,0,.36.31.56.55.71.03.02.06.04.1.06h0c.28.16.57.33.57.59,0,.24-.2.35-.45.35-.31,0-.55-.11-.77-.33v.47c.22.15.51.21.77.21.51,0,.81-.33.81-.73,0-.47-.37-.68-.79-.91h-.02s0-.01,0-.01Zm2.32.44h1.04v-.35h-1.04v-.83h1.08v-.34h-1.47v2.7h1.51v-.34h-1.12v-.84Zm3.03-.51l.74-1.01h.47l-1,1.35v1.35h-.4v-1.35l-1-1.35h.47l.72,1.01Z" fill-rule="evenodd"/><rect x="1" y="1" width="52" height="52" fill="none" stroke="var(--sey-bag-border, #000)"/></svg>`;
  };

  const ERROR = {
    error: true
  }

  const SUCCESS = {
    ok: true
  }

  const ERROR_CODES = {
    "API_ERROR": "apiError",
    "CREATE": "apiError",
    "REACTIVATE": "apiError",
    "SELECTIONS": "apiError",
    "CANCEL": "apiError",
    "SWAP": "apiError",
    "ZERO_AMOUNT": "zeroAmount",
    "UPDATE_ADDRESS": "apiError",
    "SKIP_CHARGE_ERROR": "apiError"
  }

  const ERROR_MESSAGES = {
    "zeroAmount": "You cannot update your subscription while total amount is zero",
    "apiError": "Unable to process this request. Please reach out to customer service at <a href='mailto:hello@sey.coffee'><strong>hello@sey.coffee</strong></a>"
  }

  const getIcons = function(icon, quantity) {
    let icons = "";
    if ( Number.isInteger(quantity) ) {
      for ( let i = 0; i < quantity; i++) {
        icons = icons += icon(i);
      }
      if ( quantity === 0 ) {
        icons = icon(0);
      }
    }
    return icons
  }

  const priceWrapper = function(key) {
    return `
      <div data-key="${key}" class="${PRICE_WRAPPER_CL}">
        <div class="item ${PRICE_COMPARED_CL}"></div>
        <div class="item ${PRICE_CL}">}</div>
      </div>`;
  }

  const renderProduct = function ({
    title,
    icon,
    quantity,
    price,
    type,
    key,
    option
  }) {
    let iconRow = '', priceRow = '';
    if ( icon ) {
      iconRow = `<div class="m__icon-wrapper"><div class="m__icon ${quantity == 0 ? DIM : ''}">${getIcons(icon, quantity)}</div></div>`;
    }
    if ( type === CAF) {
      priceRow = priceWrapper(key);
    }
    return `
      <div data-module="product" data-key="${key}" data-type="${type}" data-option="${option}" class="${type.toLowerCase()}">
        ${ icon ? iconRow : ''}
        <div class="m__title font-serif">${title}</div>
        <div class="m__type font-serif">${type}</div>
        <div class="m__quantity font-serif row-between-center">
          <button class="m__btn font-serif ${DECREASE}">-</button>
          <input class="font-serif" type="number" min="0" readonly="true" data-key="${key}" data-type="${type}" value="${quantity}"/>
          <button class="m__btn font-serif ${INCREASE}">+</button>
        </div>
        ${priceRow}
      </div>
    `
  }
  const renderWidget = function(sizes, types = {}) {

    let cafSlot = "";
    let decafSlot = "";
    let html;
    Object.keys(types[TWO_FIFTY])
    .forEach(function(type) {
      Object.keys(sizes)
      .forEach(function(size) {
        const sizeOptions = sizes[size];
        const ref = sizeOptions[0];
        const sizeLower = ref.size?.toLowerCase();
        html = renderProduct({
          title: ref.size,
          icon: sizeLower.includes(BOX_OPTION) ? boxSVG : bagSVG,
          price: ref.price,
          quantity: 0,
          type: type,
          key: size,
          option: (sizeLower.includes(BOX_OPTION) ? BOX_OPTION : BAG_OPTION)
        });

        if ( type === CAF) {
          cafSlot += html;
        } else {
          decafSlot += html;
        }
      })
    })
    return `
      <div class="widget ${CAF.toLowerCase()}">
        ${cafSlot}
      </div>
      <div class="widget ${DE_CAF.toLowerCase()}">
        ${decafSlot}
      </div>
      <div class="widget price">
        ${priceWrapper(TWO_FIFTY)}
        ${priceWrapper(TWO_POUND)}
      </div>
    `
  }
  const getProductJson = async function(url) {
    try {
      const response = await fetch(url, {
        method: 'GET',
      });
      return await response.json();
    } catch (err) {
      console.error(err);
    }

  }
  return {
    SUCCESS,
    ERROR,
    ERROR_CODES,
    ERROR_MESSAGES,
    SUBSCRIPTION,
    REVEAL,
    INCREASE,
    DECREASE,
    CAF,
    DE_CAF,
    COFFEE,
    TWO_POUND,
    TWO_FIFTY,
    BAG_OPTION,
    BOX_OPTION,
    ZERO_DOLLAR,
    DIM,
    PRICE_WRAPPER_CL,
    PRICE_CL,
    PRICE_COMPARED_CL,
    box: {
      svg: boxSVG
    },
    bag: {
      svg: bagSVG
    },
    renderWidget,
    getProductJson,
    getIcons,
  }
})();

RS.events = (function() {
  var defaultProps = {
    bubbles: true,
    cancelable: true
  }

  var customEvent = function(type, payload, override) {
    var props = Object.assign({}, defaultProps);
    if ( payload ) {
      props.detail = payload;
    }
    if (override) {
      props = Object.assign(props, override);
    }
    return new CustomEvent(type, props);
  }
  return {
    ERROR_EVENT: 'event:error',
    CHANGE_EVENT: 'change', // default change event
    PORTAL_UPDATE: 'event:portalUpdate',
    customEvent: customEvent,
    SKIP_ERROR: 'event:skipError',
    ADDRESSES_OBJ_UPDATE: 'event:addressesObjUpdate',
    ERROR_ADDRESSES_UPDATE: 'error:addressesUpdate'
  }
})();

RS.recharge = (function() {
  const { TWO_POUND, TWO_FIFTY, ERROR_CODES, ERROR, SUCCESS } = RS.template;
  const { ERROR_EVENT, customEvent } = RS.events;

  const CANCEL = 'cancel'; 		 	    // [key] column is cancelled
  const REACTIVATE = 'reactivate';  // [key] column to reactivate
  const CREATE = 'create'; 		 	    // [key] column to create
  const ACTIVE = 'ACTIVE'; 		 	    // [key] subscrription status
  const CANCELLED = 'CANCELLED'; 	  // [key] subscrription status
  const RS_BUNDLE = 'rs_bundle';
  const UI_ADJUSTMENT = 'ui_adjustment';

  let activeSubscription = {};
  let activeId;

  const template = function({
    variantId,
    productId,
    selections
  }) {
    return {
      "externalVariantId": variantId,
      "externalProductId": productId,
      "selections": selections
    };
  }

  const getBundleId = async function (params) {
    const bundle = template({
      ...params
    });
    const isValid = await recharge?.bundle?.validateBundle(bundle);

    if ( isValid ) {
      const rbId = await recharge?.bundle?.getBundleId(bundle).catch((e) => {
        console.log("****** | file: custom.js | getBundleId | e:", e)
      });
      return rbId;
    } else {
      console.error('There is an issue with ReCharge bundle');
      return null;
    }
  };

  const getSelection = function(option, quantity) {
    let selected = {};
    if ( option ) {
      const { collectionId, productId, variantId } = option;
      selected = {
        collectionId,
        externalProductId: productId,
        externalVariantId: variantId,
        quantity
      }
    }
    return selected;
  }

  const processSubscription = function(sub) {
    const { product, status, id , variant_title, customer_id, order_interval_frequency, order_interval_unit, charge_interval_frequency, first_charge_date, next_charge_scheduled_at, is_prepaid, price, shopify_product_id, shopify_variant_id, address_id, properties, cancellation_reason } = sub;
      const keys = [TWO_FIFTY, TWO_POUND];
      const firstKey = variant_title.split(' ')?.[0];
      const key = keys.includes(firstKey) ? firstKey : '';
      const prepay = is_prepaid ? `${charge_interval_frequency}${order_interval_unit}` : '';

      return {
        id,
        key,
        status,
        subscriptionId: id,
        cancellation_reason,
        productId: shopify_product_id,
        variantId: shopify_variant_id,
        address_id,
        customer_id,
        variant_title,
        first_charge_date,
        next_charge_scheduled_at,
        is_prepaid,
        order_interval_frequency,
        order_interval_unit,
        charge_interval_frequency: charge_interval_frequency ? parseInt(charge_interval_frequency,10): 28,
        prepay,
        price,
        properties: {...properties},
        product
      }
  }

  const findProp = function(props, str) {
    const prop = props?.find(function(prop) { return prop.name === str });
    return prop?.value;
  }

  const getBundledSubscriptions = function (subs) {
    let bundled = [], bundleId;
   	const active = subs.find(function(sub) {
      return sub.id === activeId;
    });
    if ( active ) {
      activeSubscription = {...active};
      const { properties, cancellation_reason } = active;
      if ( active.status === ACTIVE ) {
      	bundleId = findProp(properties, RS_BUNDLE);
      } else if ( active.status === CANCELLED ) {
        bundleId = cancellation_reason ? cancellation_reason.split(':')[1] : '';
      }
      bundled = subs.filter(function(sub) {
        const { properties, cancellation_reason } = sub
        const cancelledId = cancellation_reason ? cancellation_reason.split(':')[1] : '';
        const RsBundleId = findProp(sub.properties, RS_BUNDLE);
        if ( RsBundleId === bundleId || cancelledId === bundleId ) {
          return sub;
        }
      });
    }
    return bundled ;
  }

  const parseSubscriptions = function(subs) {
    const subscriptions = getBundledSubscriptions(subs);
    const json = subscriptions.map(function(sub) {
    	return processSubscription(sub);
    });
    return json;
  }

  const getSubscriptionById = async function(id) {
    if ( id ) {
      let schema = '{"subscription": {}}';
      const url = `/tools/recurring/portal/{{ customer.hash }}/subscriptions/${id}?token=${window.customerToken}&schema="${schema}"`;
      const response = await RS.io.get(url);
      return response;
    }
  }

  const getSubscriptions = async function() {
    // TODO pulled in addresses
    const schema = '{ "addresses": [], "subscriptions": { "product": {} }}';
    const url = `/tools/recurring/portal/{{ customer.hash }}/request_objects?token=${window.customerToken}&schema=${schema}`;
    const response = await RS.io.get(url);
    const subs = parseSubscriptions([...response.subscriptions]);
    return subs;
  }

  const __updateSelections = async function(params) {
    return await Object.keys(params).reduce(async (promise, key) => {
      await promise;
      const param = params[key];
      const { selections, subscriptionId } = param;
      if ( !subscriptionId && selections.length === 0 ) {
        return await promise;
      };
      const payload = {
        bundle_selection: {
          selections: []
        },
      };
      selections.forEach(function(select) {
        payload.bundle_selection.selections.push({
          collection_id: select.collectionId,
          external_product_id: select.productId,
          external_variant_id: select.variantId,
          quantity: select.quanity,
        })
      });
      const url = `/tools/recurring/portal/{{ customer.hash }}/subscriptions/${subscriptionId}/bundles?token=${window.customerToken}`;
      const response = await RS.io.post(url, payload);
      /*if ( !response?.bundle_selection ) {
      	const error = customEvent(ERROR_EVENT, ERROR_CODES.SELECTIONS);
      	document.dispatchEvent(error);
        return ERROR;
      }*/
    }, Promise.resolve());
  }

  const updateSelections = async function(params) {
    let resp = {};
    const keys = Object.keys(params || {});
    for (const key of keys) {
      const param = params[key] || {};
      const { selections, subscriptionId } = param;
      if (subscriptionId && selections.length) {
        const url = `/tools/recurring/portal/{{ customer.hash }}/subscriptions/${subscriptionId}/bundles?token=${window.customerToken}`;
        const payload = {
          bundle_selection: {
            selections: []
          },
        };
        selections.forEach(function(select) {
          payload.bundle_selection.selections.push({
            collection_id: select.collectionId,
            external_product_id: select.productId,
            external_variant_id: select.variantId,
            quantity: select.quanity,
          })
        });
        const response = await RS.io.post(url, payload);
        if ( !response?.bundle_selection ) {
          const error = customEvent(ERROR_EVENT, ERROR_CODES.SELECTIONS);
          document.dispatchEvent(error);
          resp = ERROR;
        }
      }
    }
    return resp;
  }

  const swapSubscription = async function(param) {
      const { variantId, properties, subscriptionId, timestamp } = param;
      const url = `/tools/recurring/portal/{{ customer.hash }}/subscriptions/${subscriptionId}/swap?token=${window.customerToken}`;
      const response = await RS.io.post(url, {
        shopify_variant_id: variantId,
        "properties[Contents]": properties.join('\n'),
        "properties[rs_bundle]": timestamp,
      });
      if ( !response?.subscription ) {
      	const error = customEvent(ERROR_EVENT, ERROR_CODES.SWAP);
      	document.dispatchEvent(error);
        return ERROR;
      }
  }

  const checkValidDate = function(date) {
    let bool = true;

    if ( date ) {
      const day = 60 * 60 * 1000 * 24;
      const now = new Date().getTime();
      const ts = new Date(date).getTime();
      const delta = (ts - now) / day;
      if ( delta < -1 ) {
        bool = false;
      }
    } else {
      bool = false;
    }
    return bool;
  }

  const createSubscription = async function(param) {
    const { action: {subscription}, variantId, quantity, properties, timestamp } = param;
    const url = `/tools/recurring/portal/{{ customer.hash }}/subscriptions?token=${window.customerToken}`;
    if ( checkValidDate(subscription?.next_charge_scheduled_at) === false ) {
      const createError = customEvent(ERROR_EVENT, ERROR_CODES.CREATE);
      document.dispatchEvent(createError);
      return ERROR;
    } else {
      const data = {
        "shopify_variant_id": variantId,
        "order_interval_frequency": subscription?.order_interval_frequency,
        "order_interval_unit": subscription?.order_interval_unit,
        "charge_interval_frequency": subscription?.charge_interval_frequency,
        "next_charge_scheduled_at": subscription?.next_charge_scheduled_at,
        "address_id": subscription?.address_id,
        "quantity": 1,
        "properties[Contents]": properties.join('\n'),
        "properties[rs_bundle]": timestamp
      }
      const response = await RS.io.post(url, data);
      return response?.subscription?.id;
    }
  }

  const cancelSubscription = async function(param) {
    const { action: { subscription }, timestamp} = param;
    const { subscriptionId, address_id } = subscription;
    if ( subscriptionId, address_id ) {
    	const url = `/tools/recurring/portal/{{ customer.hash }}/addresses/${address_id}/subscriptions-bulk-update?token=${window.customerToken}`;
      let data = {
        "subscriptions":[
          {
            "id": subscriptionId,
            "status": CANCELLED,
            "cancellation_reason": `${UI_ADJUSTMENT}:${timestamp}`
          }
        ]
      }
      const response = await RS.io.post(url, data);
      if ( !response.subscriptions ) {
        const error = customEvent(ERROR_EVENT, ERROR_CODES.CANCEL);
        document.dispatchEvent(error);
        return ERROR;
      } else {
        return response;
      }
    }
  }
  const reactivateSubscription = async function(param) {
    const { action: { subscription }, timestamp} = param;
    const { subscriptionId, address_id } = subscription;
    const url = `/tools/recurring/portal/{{ customer.hash }}/addresses/${address_id}/subscriptions-bulk-update?token=${window.customerToken}`;

    // Reactivate subscriptions object
    let data = {
      "subscriptions":[
        {
          "id": subscriptionId,
          "status": ACTIVE,
        }
      ]
    }
    const reactivate = await RS.io.post(url, data);
    if ( !reactivate?.subscriptions ) {
      const error = customEvent(ERROR_EVENT, ERROR_CODES.REACTIVATE);
      document.dispatchEvent(error);
      return ERROR;
    }
    const swap = await swapSubscription(param);
    if ( swap?.error ) {
      return ERROR;
    }
  }
  const hadleSubscription = async function(params) {
    let error;
    return await Object.keys(params).reduce(async (promise, key) => {
      await promise;
      const param = params[key];
      const method = param?.action?.method;

      if ( method === CREATE) {
        const response = await createSubscription(param);
        if ( response?.error ) {
          error = ERROR;
        } else {
          param.subscriptionId = response;
        }
      } else if ( method === CANCEL) {
        const cancel = await cancelSubscription(param);
        if ( cancel?.error ) {
          error = ERROR;
        }
      } else if ( method === REACTIVATE) {
        const reactivate = await reactivateSubscription(param);
        if ( reactivate?.error ) {
          error = ERROR;
        }
      } else {
        if ( params[key].quantity > 0 ) {
          const swap = await swapSubscription(param);
          if ( swap?.error ) {
          	error = ERROR;
          }
        }
      }

      if ( error ) {
        return ERROR;
      }
    }, Promise.resolve());
  }

  const updateSubscriptionProperties = async function (subscription_id, props) {
    const url = `/tools/recurring/portal/{{ customer.hash }}/subscriptions/${subscription_id}?token=${window.customerToken}`;
    const data = {
      charge_interval_frequency: "28",
      order_interval_frequency: "28",
      order_interval_unit: "day",
      quantity: "1",
      props,
    }
    const response = await RS.io.post(url, data);
  }

  const updateBundle = async function(params) {
    const response = await hadleSubscription(params);
    if ( response?.error ) return ERROR; // break out due to an error
    const selections = await updateSelections(params);
    if ( selections?.error ) return ERROR; // break out due to an error
    const subscriptions = await getSubscriptions();
    return subscriptions;
  }

  const setActiveId = function(id, update = true) {
  	activeId = id;
    if ( update ) {
    	RS.widget.updatePortal();
    }
  };

  const cancelSubscriptions = async function(params) {
    return await Object.keys(params).reduce(async (promise, key) => {
      await promise;
      const param = params[key];
      if ( !param.action ) {
        return {};
      }

      const response = await cancelSubscription(param);
      return response;
    }, Promise.resolve());
  }

  const getAddresses = async function() {
    const address = {};
    const schema = '{ "addresses": {"subscriptions": [], "onetimes": []} }';
    const url = `/tools/recurring/portal/{{ customer.hash }}/request_objects?token=${window.customerToken}&schema=${schema}`;
    const response = await RS.io.get(url);
    return response?.addresses ? response.addresses : [];
  };

  const processAddresses = async function() {
    const addresses = await getAddresses();
    let addressObj = {};
    if (addresses.length) {
      addressObj = addresses.reduce((obj, address) => {
        obj[address.id] = address;
        return obj;
      }, addressObj);
      updateAddressObj(addressObj);
    }
    return addressObj;
  };

  const updateAddressObj = function(addressesObj) {
    if (addressesObj) {
      const addressesObjUpdated = customEvent(RS.events.ADDRESSES_OBJ_UPDATE, addressesObj);
      ReCharge.Novum.addressesObj = addressesObj;
      document.dispatchEvent(addressesObjUpdated);
    }
  };

  return {
    CANCEL,
    REACTIVATE,
    CREATE,
    ACTIVE,
    CANCELLED,
    RS_BUNDLE,
    getBundleId,
    getSelection,
    getSubscriptions,
    parseSubscriptions,
    updateBundle,
    updateSubscriptionProperties,
    getSubscriptionById,
    getActiveId: function() { return activeId }, // active subscription id
    getActiveSubscription: function() { return activeSubscription }, // active subscription json
    getBundledSubscriptions,
    setActiveId,
    cancelSubscriptions,
    getAddresses,
    updateAddressObj,
    processAddresses
  }
})();

RS.io = (function() {
  const get = async function(url) {
    const result = await fetch(url)
      .then(async (response) => {
        if (response.ok) {
          return response.json();
        } else {
          return response;
        }
      })
      .catch((error) => {
        console.log(error);
        return null
      });
    return result
  }
  const post = async function(url, data) {
    const result = await fetch(url, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        return response;
      }
    })
    .catch((error) => {
      console.log(error);
      return null
    });
    return result
  }
  return {
    get,
    post
  }
})();

RS.widget = (function() {
  const {
    ERROR_CODES,
    ERROR_MESSAGES,
    renderWidget,
    getProductJson,
    getIcons,
    DIM,
    CAF,
    DE_CAF,
    COFFEE,
    TWO_POUND,
    TWO_FIFTY,
    REVEAL,
    SUBSCRIPTION,
    INCREASE,
    DECREASE,
    ZERO_DOLLAR,
    PRICE_WRAPPER_CL,
    PRICE_CL,
    PRICE_COMPARED_CL
  } = RS.template;

  const {
    CANCEL,
    REACTIVATE,
    CREATE,
    ACTIVE,
    CANCELLED
  } = RS.recharge;

  const { ERROR_EVENT, CHANGE_EVENT, customEvent } = RS.events;

  const TITLE_EL = '.sub__title';
  const SUBTITLE_EL = '.sub__subtitle';
  const SUBDESC_EL = '.sub__description';
  const WIDGET_EL = '[data-module="widget"]';
  const TOGGLE_EL = 'input[name="decaf"]';
  const SUBMIT_EL = '.sub__submit';
  const ADJUST_EL = '.m__quantity .m__btn';
  const ICON_EL = '.m__icon';
  const PROD_EL = '[data-module="product"]';
  const QTY_EL = '.m__quantity input[type="number"]';
  const TOTAL_EL = '[data-module="subscription"] .sub__amount';
  const MESSAGE_EL = '[data-module="subscription"] .sub__message';
  const PREPAY_EL = '.sub__form-group .sub__prepay';
  const PREPAY_TOGGLE_EL = 'input[name="prepay"]';
  const PREPAY_SELECT_EL = 'select[name="prepay-dropdown"]';
  const PREPAY_DICSOUNT_EL = 'label[for="sub__prepay"] .discount';
  const PREPAY_SAVING_EL = '.sub__bottom-row .saving';
  const GROUP_DROPDOWN_EL = '.sub__input-group.prepay-dropdown';
  const PRICE_WRAPPER_EL = `${WIDGET_EL} .${PRICE_WRAPPER_CL}`;
  const PRICE_EL = `.${PRICE_CL}`;
  const PRICE_COMPARED_EL = `.${PRICE_COMPARED_CL}`;
  const ERROR_EL = '.sub__error';

  const PORTAL_SUBMIT = 'Update Subscription';
  const DEFAULT = 'default';
  const SELLING_PLAN = 'sellingPlan';
  const THRESHOLD = 6;
  const CONTENTS = 'Contents';
  const NOTE = 'note';
  const HIDDEN = 'hidden';
  const DISABLED = 'disabled';
  const PREPAID = 'prepaid';
  const SIX_MONTH = '168day';
  const TWELVE_MONTH = '336day';
  const PROCESSING = 'processing...';
  const NO_UPDATE = 'Prepaid subscriptions cannot be modified';
  const PREPAID_DESC = 'To make changes to your prepaid subscription, please contact <a href="mailto:subscriptions@sey.coffee?subject=Make changes to my prepaid subscriptions">subscriptions@sey.coffee</a>';
  const EMPTY = 'empty';
  const FADE_IN = 'fade-in';
  const SIZES = [
    `${TWO_FIFTY}`,
    `${TWO_POUND}`
  ];
  const SIZES_REVERSE = SIZES.slice().reverse();
  const PREFIX = '_bundle_';
  const PROP_DELIMITER = '*****\n';
  const BUNDLE_KEY = '_bundle_key';
  const BUNDLE_TYPES = '_bundle_types';
  const changeEvent = customEvent(CHANGE_EVENT);

  let containerEl, widgetEl, titleEl, subTitleEl, decafToggleEl, submitEl, totalEl, qtyEls, priceWrapperEls, messageEl, prepayEl, prepaySelectEl, prepayToggleEl, prepayDiscountEl, prepaySavingEl, groupDropdwonEl, errorEl, subDescEl;
  let maxCount, subscription, subscriptionJson, _isPortal, _isPrepaid, _noInteraction;
  let productJson = {}, prepayJson = {};
  let hasError = false;
  const initialize = async function ({ container, product, isPortal = false }) {
    _isPortal = isPortal;
    _noInteraction = false;
    containerEl = container;
    decafToggleEl = containerEl.querySelector(TOGGLE_EL);
    titleEl = containerEl.querySelector(TITLE_EL);
    subTitleEl = containerEl.querySelector(SUBTITLE_EL);
    widgetEl = containerEl.querySelector(WIDGET_EL);
    submitEl = containerEl.querySelector(SUBMIT_EL);
    totalEl = containerEl.querySelector(TOTAL_EL);
    messageEl = containerEl.querySelector(MESSAGE_EL);
    prepayEl = containerEl.querySelector(PREPAY_EL);
    prepaySelectEl = containerEl.querySelector(PREPAY_SELECT_EL);
    prepayToggleEl = containerEl.querySelector(PREPAY_TOGGLE_EL);
    prepayDiscountEl = containerEl.querySelector(PREPAY_DICSOUNT_EL);
    prepaySavingEl = containerEl.querySelector(PREPAY_SAVING_EL);
    groupDropdwonEl = containerEl.querySelector(GROUP_DROPDOWN_EL);
    errorEl = containerEl.querySelector(ERROR_EL);
    subDescEl = containerEl.querySelector(SUBDESC_EL)
    setup(product);
    initEvents();
    initSubmitEvent();
  }

  const updateQuantity = function(order) {
    qtyEls.forEach(function(el) {
      const parentEl = el.closest(PROD_EL);
      const { option } = parentEl.dataset;
      const { key, type } = el.dataset;
      let value = order?.[key]?.[type];
      if ( value ) {
        let quantity = typeof value === 'number'? value : 0;
        el.setAttribute('value', quantity);
        el.dispatchEvent(changeEvent);
        renderIcons(parentEl, RS.template[option].svg, value);
      }

      if ( order[key] && order[key].isPrepaid ) {
        parentEl.classList.add(DISABLED);
      }
    });
    calculateTotal();
  }
  
  const toggleSubmit = function(enable) {
    if ( enable ) {
      submitEl.classList.remove(DISABLED);
    } else {
      submitEl.classList.add(DISABLED);
    }
  }

  const enableSubmit = function(enable, string) {
     _noInteraction = !enable;
    toggleSubmit(enable);
    if (enable) {
      const { defaults } = submitEl.dataset;
      if ( defaults ) {
        submitEl.value = defaults;
      }
    } else {
      if (string) {
      	submitEl.value = string;
      }
    }
  }

  const updatePortalElements = function(data) {
    if ( _isPrepaid ) {
      containerEl.dataset.isPrepaid = true;
      const { product } = data[0];
      if (subTitleEl) {
      	subTitleEl.textContent = NO_UPDATE;
      }
      if ( subDescEl ) {
        subDescEl.innerHTML = PREPAID_DESC;
      }
    }
  }

  const getPropertyContent = function(props) {
    if ( props ) {
      const key = Object.keys(props).filter(function(prop) {
        return props[prop].name.includes(CONTENTS);
      });
      return props[key];
    }
  }

  const updatePortal = async function(subscriptions) {
    const { PORTAL_UPDATE } = RS.events;
    const updateEvent = customEvent(PORTAL_UPDATE);

    if ( subscriptions) { // retrieved after portal update
      	subscriptionJson = [...subscriptions];
    } else {
    	const portalData = await RS.recharge.getSubscriptions();
    	if ( !portalData && !portalData.length ) return;
    	subscriptionJson = [...portalData];
    }

    if ( !_isPrepaid ) {
    	_isPrepaid = subscriptionJson[0].is_prepaid;
    }
    updatePortalElements(subscriptionJson);

    submitEl.dataset.defaults = PORTAL_SUBMIT;
    submitEl.value = PORTAL_SUBMIT;
    let order = {};
    let toggled = false;
    let subscriptionIndex;
    let prepay;
    let contents;
    subscriptionJson.forEach(function(sub, index) {
      if ( !prepay ) {
        prepay = sub.prepay; // 6month, 12month
      }

      const { key, properties, status } = sub;
      const contentProp = getPropertyContent(properties);
      if ( contentProp ) {
      	contents = contentProp?.value?.replace('\\n', '\n').split('\n');
      }

      if ( contents && status === ACTIVE ) {
        if ( !subscriptionIndex ) {
          subscriptionIndex = index;
        }
        contents.forEach(function(content) {
          let quantity = content?.split('x ')[0];
          quantity = quantity ? parseInt(quantity,10) : 0;
          const key = content?.split(' ')[1];
          const type = content?.split(' ')[2];
          if ( !order[key]) {
            order[key] = {};
          }
          order[key][type] = quantity;
          order[key].price = sub.price;
          if (typeof order[key].isPrepaid === 'undefined') {
            order[key].isPrepaid = sub.is_prepaid;
            if ( order[key].isPrepaid ) {
            	enableSubmit(false);
            }
          }

          if (!toggled && type === DE_CAF ) { // reveal the decaf row
            toggled = true;
            widgetEl.classList.add(REVEAL);
            decafToggleEl.setAttribute('checked', true);
            decafToggleEl.setAttribute('disabled', true);
          }
        });
      } else if ( status === CANCELLED ) {
        order[key] = {
          status: CANCELLED
        }
      }
    });
    updateQuantity(order);
    if ( prepay ) {
      subscription = prepay;
    	await checkData(subscription);
    	updateAllPrices();
    	calculateTotal();
    }
    document.dispatchEvent(updateEvent);
  }

  const formatJson = function(prod) {
    let productTypes = {}, productSizes = {}, variants = [], sellingPlanId, collectionId;
    // collection ID
    collectionId = prod.collectionId;
    // coffee types
    Object.keys(prod.types || {}).map(function(key) {
      productTypes[key] = {};
      const type = prod.types[key];
      type.map(function(o) {
        productTypes[key][o.type] = o;
      });
    });
    // parsing variants
    variants = prod?.variants?.map(function(variant) {
      const price = (variant.price / 100 );
      return {
        id: variant.id,
        title: variant.title,
        price: price,
        options: variant.options,
        size: variant.options[0],
        quantity: parseInt(variant.options[1],10)
      }
    }) || [];
    // selling plan id
    const spg = prod.selling_plan_groups;
    if ( spg && spg.length) {
      var sp = spg[0].selling_plans;
      sellingPlanId = sp?.length ? sp[0].id : null;
    }

    // Product Grid
    SIZES.forEach(function(key) {
      productSizes[key] = variants.filter(function(variant) {
        return ( variant.title.includes(key));
      });
      if ( key === TWO_FIFTY ) {
        maxCount = productSizes[key].length;
      }
    });
    return {
      subscription,
      id: prod.id,
      collectionId,
      sellingPlanId,
      productSizes: {...productSizes},
      productTypes: {...productTypes},
      variants,
    };
  }

  const setup = function(prod) {
    // subscription
    subscription = DEFAULT;

    // prepay
    prepayJson = prod ? {...prod.prepay} : {};

    productJson[subscription] = formatJson(prod);
    render();
  }

  const showErrorMessage = function(code) {
    if ( errorEl && ERROR_MESSAGES[code] ) {
      errorEl.innerHTML = ERROR_MESSAGES[code];
      errorEl.classList.add(FADE_IN);
    }
  }

  const renderPrepay = function() {
    if ( !_isPortal ) {
      let options = '';
      Object.keys(prepayJson).reverse().forEach(function(key) {
        const option = prepayJson[key];
        options += `<option value="${key}" data-discount="${option.discount}">${option.length}</option>`
      });
      prepaySelectEl.innerHTML = options;
    }
  }

  const render = function() {
    widgetEl.innerHTML = renderWidget(productJson[subscription].productSizes, productJson[subscription].productTypes);
    qtyEls = Array.from(containerEl.querySelectorAll(QTY_EL));
    priceWrapperEls = Array.from(containerEl.querySelectorAll(PRICE_WRAPPER_EL));
    renderPrepay();
    updateAllPrices();
    calculateTotal();
  }

  const renderIcons = function(parentEl, icon, quantity) {
    const iconEl = parentEl.querySelector(ICON_EL);
    let icons = "";
    if ( Number.isInteger(quantity) ) {
      icons = getIcons(icon, quantity);
      if ( quantity === 0 ) {
        iconEl.classList.add(DIM);
      } else {
        iconEl.classList.remove(DIM);
      }
    }
    iconEl.innerHTML = icons;
  }

  /*
   * If a key is passed then the max count is constrained on [250g|2lb] column
   */
  const getQuantityTotal = function(key) {
    let sum = 0;
    qtyEls.forEach(function(el) {
      let value = parseInt(el.value, 10);
      if ( key ) {
        if ( key === el.dataset.key ) {
          sum += value;
        }
      } else {
        sum += value;
      }
    });
    return sum;
  }

  const adjustQuantity = function(el) {
    const parentEl = el.closest(PROD_EL);
    if ( parentEl ) {
      const { key, option } = parentEl.dataset;
      const colTotal = getQuantityTotal(key);
      const qtyEl = parentEl.querySelector(QTY_EL);
      const quantity = parseInt(qtyEl.value, 10);
      let amount = quantity;

      // constrain on total
      if ( el.classList.contains(INCREASE) && colTotal < maxCount ) {
        amount = quantity + 1;
      }

      if ( el.classList.contains(DECREASE) ) {
        const value = quantity - 1;
        if ( _isPortal ) {
          if ( colTotal >= 0 && value >= 0) {
            amount = value;
          }
        } else {
          if ( value >= 0 ) {
            amount = value;
          }
        }
      }
      if ( amount !== quantity ) {
        qtyEl.setAttribute('value', amount);
        qtyEl.dispatchEvent(changeEvent);
        renderIcons(parentEl, RS.template[option].svg, amount);
      }

      if ( _isPortal ) {
        const total = getQuantityTotal();
        if ( total === 0 ) {
          toggleSubmit(false);
          showErrorMessage(ERROR_CODES.ZERO_AMOUNT);
        } else if (!submitEl.classList.contains(DISABLED) || total > 0 ) {
          toggleSubmit(true);
          errorEl.innerHTML = '';
          errorEl.classList.remove(FADE_IN);
        }
      }
    }
  }

  const getTypeOption = function(key, type, defaults = false) {
    if ( defaults ) {
      return productJson[DEFAULT].productTypes[key][type];
    } else {
      return productJson[subscription].productTypes[key][type];
    }
  }

  const getSizeOption = function(key, quantity, defaults = false) {
    let subType;
    if ( defaults ) {
      subType = DEFAULT;
    } else {
      subType = subscription;
    }
    return productJson[subType]?.productSizes[key]?.find(function(prod) {
      return prod.quantity == quantity;
    })
  }

  const getOptionByEl = function(parentEl) {
    if ( parentEl ) {
      const key = parentEl.dataset.key;
      const qtyEl = parentEl.querySelector(QTY_EL);
      const quantity = parseInt(qtyEl.value, 10);
      return getSizeOption(key, quantity);
    }
  }

  const getSubscriptionByKey = function(subscriptions, key) {
    return subscriptions.find(function(sub) {
      return sub.key === key;
    })
  }

  const updatePriceWithWrapper = function({
    el,
    price,
    compared
  }) {
    const priceEl = el?.querySelector(PRICE_EL);
    const comparedEl = el?.querySelector(PRICE_COMPARED_EL);
    const adjustedPrice = price > 0 ? `$${price.toFixed(2)}`: ZERO_DOLLAR; // the design is using empty space which can only be rendered with html

    if ( priceEl ) {
      priceEl.innerHTML = adjustedPrice;
    }
    const adjustedCompared = compared > 0 ? `$${compared.toFixed(2)}` : ZERO_DOLLAR;
    if ( comparedEl ) {
      if ( price === compared ) {
        comparedEl.classList.add(HIDDEN);
      } else {
        comparedEl.classList.remove(HIDDEN);
      }
      comparedEl.innerHTML = adjustedCompared;
    }
  }

  /*
   * update by key takes care of one column of quantity inputs
   */
  const updatePriceByKey = function(key) {
    const quanityEls = getQtyElementsByKey(key);
    const wrapperEls = getPriceWrapperByKey(key);
    const firstOption = getSizeOption(key, 1, true);
    const basePrice = firstOption.price;
    let quanity = 0;
    quanityEls.forEach(function(el) {
      if ( el ) {
        quanity += parseInt(el?.value, 10);
      }
    });
    const sumOption = getSizeOption(key, quanity, true);
    const price = sumOption ? sumOption.price : 0;
    const compared = basePrice * quanity;
    wrapperEls.forEach(function(el) {
      updatePriceWithWrapper({
        el,
        price,
        compared
      });
    });
  }

  /*
   * update both columns of quantity inputs
   */
  const updateAllPrices = function() {
    SIZES.forEach(function(key) {
      updatePriceByKey(key);
    });
  }

  const showMessage = function(count) {
    if ( count > THRESHOLD ) {
      messageEl.classList.remove(HIDDEN);
    } else {
      messageEl.classList.add(HIDDEN);
    }
  }

  const updateSavings = function(amount) {
    if ( typeof amount === 'number' && prepaySavingEl && subscription !== DEFAULT ) {
      prepaySavingEl.innerHTML = `<span>&nbsp;(</span><span class="saving font-serif">$${amount.toFixed(2)}</span><span class="font-serif"> per shipment)</span>`
    } else {
      prepaySavingEl.innerHTML = '';
    }
  }

  const calculateTotal = function() {
    let orders = {};
    let sum = 0;
    let total = 0;
    let cafTotal = 0;
    qtyEls.forEach(function(el) {
      const value = parseInt(el.value, 10);
      const { type } = el.dataset;
      if ( value > 0 ) {
        const key = el.dataset.key;
        if ( !orders[key] ) {
          orders[key] = {
            quantity: 0
          };
        }
        orders[key].quantity += value;
        total += value;
        if ( type === CAF ) {
          cafTotal += value;
        }
      }
    });
    let compared = 0;
    const selected = prepaySelectEl?.options?.[prepaySelectEl.selectedIndex];
    let subscriptionKey = selected ? selected.value : SIX_MONTH;

    const json = prepayJson[subscriptionKey];
    const discount = parseInt(json.discount);
    const percent = (( 100 - discount ) / 100).toFixed(2);

    Object.keys(orders).forEach(function(key) {
      const quantity = orders?.[key].quantity;
      const size = getSizeOption(key, quantity);

      // Use default as basis for prices
      const defaults = getSizeOption(key, quantity, true);
      const value = parseFloat(defaults.price) * percent;
      compared += value;

      if ( size ) {
        sum += size.price;
      }
    });

    totalEl.textContent = `Total $${sum.toFixed(2)}`;
    showMessage(cafTotal);
    updateSavings(compared);
    return sum;
  }
  /*
   *  Use key [TWO_FIFTY|TWO_POUND] to query price wrapper
   */
  const getPriceWrapperByKey = function(key) {
    let elems = priceWrapperEls.filter(function(el) {
      return el.dataset.key?.includes(key);
    });
    return elems;
  }

  /*
   *  Use key [TWO_FIFTY|TWO_POUND] to query quantity input fields
   */
  const getQtyElementsByKey = function(key) {
    let elems = qtyEls.filter(function(el) {
      return el.dataset.key?.includes(key);
    });
    return elems;
  }
  /*
   *  Use key [CAF|DECAF] to query quanity input fields
   */
  const getQtyElementsByType = function(includes) {
    let elems;
    if ( decafToggleEl.checked ) {
      elems = [...qtyEls];
    } else {
      elems = qtyEls.filter(function(el) {
        return el.dataset.type?.includes(includes);
      });
    }
    return elems;
  }

  const getNoteByOrderTask = function(order) {
    let counter = 1;
    let notes = [];
    if (order) {
      SIZES_REVERSE.forEach(function(key) {
        const size = order[key]?.[NOTE];
        if (size) {
          let quantity = size[CAF] ? size[CAF] : 0;
          if ( quantity > 0 ) {
            for (let i = 0; i < quantity; i++) {
              notes.push(`${COFFEE} ${counter} ${key}`);
              if (counter >= THRESHOLD ) {
                counter = 1;
              } else {
                counter += 1;
              }
            }
          }
          quantity = size[DE_CAF] ? size[DE_CAF] : 0;
          if ( quantity > 0 ) {
            for (let i = 0; i < quantity; i++) {
              notes.push(`${DE_CAF} ${key}`);
            }
          }
        }
      });
    }
    return notes.join(',\n');
  }

  const onAddToCart = async function(e) {
    e.preventDefault();
    const elems = getQtyElementsByType(CAF);
    let total = 0;
    let cartData = {
      items: []
    }
    let tasks = {};
    elems.forEach(function(el, index) {
      if ( el ) {
        const { key, type} = el.dataset;
        const option = getTypeOption(key, type);
        const quantity = parseInt(el.value, 10);

        if (!tasks[key]) {
          tasks[key] = {
            quantity: 0,
            selections: [],
            content: [],
            [NOTE]: {}
          };
        }
        if ( quantity > 0 ) {
          total += quantity;
          if ( !tasks[key].note[type] ) tasks[key].note[type] = quantity;
          tasks[key].quantity += quantity;
          tasks[key].content.push(`${quantity}x ${option.title}`);
          tasks[key].selections.push(RS.recharge.getSelection({...option}, quantity));
        }
      }
    });

    if ( total === 0 ) return;
    const TS = new Date().getTime();
    await Object.keys(tasks).reduce(async (promise, key) => {
      await promise;

      const task = tasks[key];
      const option = productJson[subscription].productSizes[key]?.find(function(o) {
        return o.quantity === task.quantity;
      });
      if (option && option.id) {
        const rbId = await RS.recharge.getBundleId({
          productId: productJson[subscription].id,
          variantId: option.id,
          selections: task.selections
        });
        if ( rbId ) {
          const types = Object.keys(tasks[key]?.note || {}) || [];
          const typesData = types.reduce((data, type) => {
            if (type) {
              const typeKey = `${PREFIX}${type}`;
              if (!data[typeKey] && tasks[key]?.note[type]) {
                data[typeKey] = tasks[key]?.note[type];
              }
            }
            return data;
          },{})
          cartData.items.push({
            id: option.id,
            quantity: 1,
            selling_plan: productJson[subscription].sellingPlanId,
            properties: {
              _rb_id: rbId,
              Contents: task.content.join('\n'),
              rs_bundle: TS,
              [BUNDLE_KEY]: key || '',
              ...typesData
            },
          });
        }
      } else {
        return Promise.resolve();
      }
    }, Promise.resolve());
    await RS.cart.add(cartData);
    window.location.href = '/cart';
  }

  // This callback only works inside ReCharge Portal
  const getBundleParams = function() {
    const TS = new Date().getTime();
    let params = {};
    SIZES.forEach(function(key, index) {
      params[key] = {};
      const els = getQtyElementsByKey(key);
      params[key].timestamp = TS;
      params[key].quantity = 0;
      params[key].properties = [];
      params[key].selections = [];
      els.forEach(function(el, index) {
        const value = parseInt(el.value,10);

        const { type } = el.dataset;
        const typeOption = getTypeOption(key, type);
        const { collectionId, productId, variantId, title} = typeOption;

        if ( value > 0 ) {
          params[key].selections.push({
            collectionId,
            productId,
            variantId,
            quanity: value
          });
          params[key].quantity += value;
          params[key].properties.push(`${value}x ${title}`);
        }
      });

      const subscription = getSubscriptionByKey(subscriptionJson, key);
      if ( params[key].quantity > 0 ) {
        const option = getSizeOption(key, params[key].quantity);
        if ( option ) {
          params[key].variantId = option.id;
        }
        const sub = subscriptionJson.find(function(sub) {
          return sub.variant_title.includes(key);
        });
        if ( sub ) {
          params[key].status = sub.status;
          params[key].subscriptionId = sub.subscriptionId;
          if ( sub.status === CANCELLED ) {
            params[key].action = {
                method: REACTIVATE,
                subscription: {...sub}
            }
          }
        } else {
           // currently no subscription use the first one
           if ( subscriptionJson.length > 0 ) {
              params[key].action = {
                  method: CREATE,
                  subscription: {...subscriptionJson[0]}
              }
           }
        }
      } else {
        // zero quantity
        if ( subscription?.status === ACTIVE ) {
          params[key].action = {
          	method: CANCEL,
          	subscription: {...subscription}
          }
        }
      }
      // Update cancelled status again to keep TS in sync
      if ( subscription?.status === CANCELLED && params[key].quantity === 0) {
        params[key].action = {
          method: CANCEL,
          subscription: {...subscription}
        }
      }
    });
    return params;
  }

  const onUpdateBundle = async function(e) {
    e.preventDefault();
    enableSubmit(false, PROCESSING);
    const params = getBundleParams();
    const response = await RS.recharge.updateBundle(params);
    if ( response.error ) return; // break out due to an erro
    await updatePortal(response);
    enableSubmit(true);
  }

  const resetIcon = function(el) {
    const parentEl = el.closest(PROD_EL);
    if ( parentEl.classList.contains(CAF.toLowerCase())) {
        const option = parentEl.dataset.option;
        renderIcons(parentEl, RS.template[option].svg, 0);
    }
  }

  const resetQuantity = function(type) {
    const elems = getQtyElementsByType(type);
    elems.forEach(function(el) {
      if ( el ) {
        el.setAttribute('value', 0);
      }
    });
    calculateTotal();
  }

  const updateDiscount = function(discount) {
    if ( prepayDiscountEl ) {
      prepayDiscountEl.textContent = `${discount}%`;
    }
  }

  const checkData = async function (subscription) {
    if ( !productJson[subscription] && prepayJson[subscription] ) {
      const prod = await getProductJson(prepayJson[subscription].url);
      if ( prod ) {
        productJson[subscription] = formatJson(prod);
      }
    }

    if ( subscription !== DEFAULT ) {
      const discount = prepayJson?.[subscription]?.discount;
      updateDiscount(discount);
    }
  }

  const resetDiscount = function() {
    const first = Object.keys(prepayJson)[0];
    const discount = prepayJson?.[first]?.discount;
    updateDiscount(discount);
  }

  const resetSelect = function (el) {
    if (el) {
      el.options[0].selected = 'selected';
    }
  }

  const cancelSubscriptions = async function() {
    enableSubmit(false);

    const params = getBundleParams();

    if ( params ) {
      Object.keys(params).forEach(function(key) {
        const param = params[key];
          if ( param.quantity > 0 ) {
          const sub = subscriptionJson.find(function(sub) {
            return sub.variant_title.includes(key);
          });
          if ( sub && !param.action && !param.action?.subscription) {
            param.action = {
              subscription: sub
            }
          }
        }
      });
    }
      
    const response = await RS.recharge.cancelSubscriptions(params);
    return response;
  }
  
  const onDecafToggle = function(e) {
    e.preventDefault();
    if ( _noInteraction ) return false;
    const bool = e.currentTarget.checked;
    if ( bool) {
      widgetEl.classList.add(REVEAL);
    } else {
      widgetEl.classList.remove(REVEAL)
      resetQuantity(DE_CAF);
      updateAllPrices();
    }
  }

  const onAdjustQuantity = function(e) {
    e.preventDefault();
    e.stopPropagation();
    if ( _noInteraction ) return false;
    const target = e.target;
    if (target.matches(ADJUST_EL)) {
      adjustQuantity(target);
    }
  }

  const initEvents = function() {
    if ( _isPortal ) {
      document.addEventListener(ERROR_EVENT, function(e) {
        const payload = e.detail;
        if ( payload && ERROR_MESSAGES[payload] ) {
          showErrorMessage(payload);
        }

        if ( payload === ERROR_CODES.API_ERROR ) {
          hasError = true;
          enableSubmit(false);
        }
      });
    }
    if ( !_isPortal ) {
      /*
       * prepay 6month/12month dropdown
       */
      prepaySelectEl.addEventListener(CHANGE_EVENT, async function(e) {
        e.preventDefault();
        const target = e.currentTarget;
        const { options, selectedIndex } = target;
        if ( prepayToggleEl.checked ) {
          subscription = options[selectedIndex].value;
          await checkData(subscription);
          updateAllPrices();
          calculateTotal();
        }
      });

      /*
       * Prepay toggle checkbox
       */
      prepayToggleEl.addEventListener(CHANGE_EVENT, async function(e) {
        e.preventDefault();
        const bool = e.currentTarget.checked;
        if ( bool) {
          subscription = prepaySelectEl.value;
          groupDropdwonEl.classList.remove(HIDDEN);
        } else {
          subscription = DEFAULT;
          groupDropdwonEl.classList.add(HIDDEN);
          resetSelect(prepaySelectEl);
          resetDiscount();
        }
        await checkData(subscription);
        updateAllPrices();
        calculateTotal();
      });
    }

    if ( !_isPrepaid ) {
      /*
      * Decaffeindated option toggle
      */
      decafToggleEl.addEventListener(CHANGE_EVENT, onDecafToggle);
    }

    /*
     * All quantity inputs
     */
    qtyEls.forEach(function(el) {
      el.addEventListener(CHANGE_EVENT, function(e) {
        const key = e.target?.dataset?.key;
        updatePriceByKey(key)
        calculateTotal();
      });
    });
    /*
     * Quantity increase/decrease 
     */
    widgetEl.addEventListener('click', onAdjustQuantity);
  }
  const initSubmitEvent = function() {
    if ( _isPortal ) {
      submitEl.addEventListener('click', onUpdateBundle);
    } else {
      submitEl.addEventListener('click', onAddToCart);
    }
  }
  return {
    NOTE,
    PREFIX,
    PROP_DELIMITER,
    BUNDLE_KEY,
    BUNDLE_TYPES,
    initialize,
    updatePortal,
    cancelSubscriptions,
    getNoteByOrderTask
  }
})();
/* END RS.widget */

RS.cart = (function() {
  const RS_BUNDLE_KEY = RS.recharge.RS_BUNDLE;
  const NOTE = RS.widget.NOTE;
  const PREFIX = RS.widget.PREFIX;
  const PROP_DELIMITER = RS.widget.PROP_DELIMITER;
  const BUNDLE_KEY = RS.widget.BUNDLE_KEY;
  const BUNDLE_TYPES = RS.widget.BUNDLE_TYPES;

  const add = async function(cartData) {
    const resp = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartData),
    });
    return resp;
  }
  const update = async function(cartData) {
    const resp = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartData),
    });
    return resp;
  }
  const get = async function() {
    let cart = {};
    let error = false;
    let errorMessage = '';
    let errorResp;
    try {
      const resp = await fetch('/cart.js');
      if (resp?.ok) {
        const data = await resp.json();
        if (data) {
          cart = data;
        }
      } else {
        error = true;
        errorMessage = "Error fetching cart";

      }
    } catch (error) {
      error = true;
      errorMessage = "Error fetching cart";
      errorResp = error;
    }

    if (error) {
      cart = {
        error: true,
        message: errorMessage,
        errorResp: errorResp
      }
    }
    return cart;
  };
  const groupCartBundles = function(cart) {
    let grouped = {};
    if (cart) {
      if (cart?.error !== true) {
        if (cart?.items?.length) {
          grouped = cart.items.reduce((data, item) => {
            const rsBundleId = item?.properties?.[RS_BUNDLE_KEY];
            if (rsBundleId) {
              if (!data[rsBundleId]) {
                data[rsBundleId] = {
                  items: [],
                  contentsData: {}
                };
              }
              const key = item?.properties?.[BUNDLE_KEY];
              if (key) {
                if (!data[rsBundleId].contentsData[key]) {
                  data[rsBundleId].contentsData[key] = {
                    quantity: 0,
                    [NOTE]: {}
                  }
                }
                const types = (item?.properties?.[BUNDLE_TYPES] || '').split(',');
                if (types.length) {
                  types.forEach((type) => {
                    const qty = item?.properties?.[`${PREFIX}${type}`]
                    if (qty) {
                      if (!data[rsBundleId].contentsData[key][NOTE][type]) {
                        data[rsBundleId].contentsData[key][NOTE][type] = qty;
                      } else {
                        data[rsBundleId].contentsData[key][NOTE][type] += qty;
                      }
                      data[rsBundleId].contentsData[key].quantity += qty;
                    }
                  });
                }
              }
            }
            return data;
          }, grouped);
        }
      }
    }
    return grouped;
  };
  const getCartBundleNote = function({ grouped, cart }) {
    const groupedKeys = grouped ? Object.keys(grouped) : [];
    const hasBundle = groupedKeys.length;
    let bundleNote = [];
    if (hasBundle) {
      groupedKeys.forEach((key) => {
        const bundleItems = grouped[key];

        if (bundleItems) {
          const order = bundleItems.contentsData;
          let itemNote = '';
          if (order) {
            itemNote = window.RS.widget.getNoteByOrderTask(order);
            if (itemNote) {
              itemNote = `Bundle ID:${key}\n${itemNote}`;
            }
          }
          if (itemNote) {
            bundleNote.push(itemNote);
          }
        }
      });
    }

    return `${bundleNote.length ? bundleNote.join('\n\n') : ''}`;
  };

  const processCurrentCartNotes = async function() {
    const cart = await get();
    const grouped = groupCartBundles(cart);
    const note = RS.cart.getCartBundleNote({ grouped, cart }) || '';
    const resp = await update({ note: note });
    return note;
  };
  return {
    add,
    get,
    groupCartBundles,
    getCartBundleNote,
    processCurrentCartNotes
  }
})();
/* END RS.cart */

document.addEventListener("DOMContentLoaded", async () => {
  const subEl = document.querySelector('[data-module="subscription"].portal');

  if (subEl) {
    let url = 'https://www.seycoffee.com/products/roasted-coffee-recurring?view=bundle-data';
    const product = await RS.io.get(url);
    RS.widget.initialize({
      container: subEl,
      product,
      isPortal: true
    });
    RS.recharge.setActiveId(ReCharge?.Novum?.subscription?.id);
  }
});